// @ts-nocheck
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import DateFormatter from "../utils/DateFormater";
import moment from "moment";
const fieldMappings = {
  "Funds Added": (payload: any) => {
    switch (payload.status) {
      case "Completed":
        return [
            { key: "transactionId", label: "Transaction ID", format: "id" },
            { key: "initiatedAt", label: "Transaction Initiated", format: "dateTime" },
            { key: "status", label: "Status", color: "status" },
            { key: "completedAt", label: "Transaction Completed", format: "dateTime" },
            { key: "amount", label: "Transaction Amount", format: "currency" },
            { key: "bankName", label: "Bank Account" },
            { key: "accountNumber", label: "Account Number", format: "mask" },
        ];
      case "In Progress":
        return [
            { key: "initiatedAt", label: "Transaction Initiated", format: "dateTime" },
            { key: "status", label: "Status", color: "status" },
            { key: "completedAt", label: "Transaction Completed", format: "dateTime" },
            { key: "amount", label: "Transaction Amount", format: "currency" },
            { key: "bankName", label: "Bank Account" },
            { key: "accountNumber", label: "Account Number", format: "mask" },
        ];
      case "Canceled":
        return [
            { key: "transactionId", label: "Transaction ID", format: "id" },
            { key: "initiatedAt", label: "Transaction Initiated", format: "dateTime" },
            { key: "status", label: "Status", color: "status" },
            { key: "completedAt", label: "Transaction Completed", format: "dateTime" },
            { key: "amount", label: "Transaction Amount", format: "currency" },
            { key: "bankName", label: "Bank Account" },
            { key: "accountNumber", label: "Account Number", format: "mask" },
        ];
      case "rejected":
        return [
            { key: "initiatedAt", label: "Transaction Initiated", format: "dateTime" },
            { key: "status", label: "Status", color: "status" },
            { key: "completedAt", label: "Transaction Completed", format: "dateTime" },
            { key: "amount", label: "Transaction Amount", format: "currency" },
            { key: "transactionDescription", label: "Rejected Reason" },
        ];
      default:
        return [];
    }
  },
  "Funds Withdrawn": (payload: any) => {
    switch (payload.status) {
      case "Completed":
        return [
          {
            key: "initiatedAt",
            label: "Withdrawn Requested On",
            format: "dateTime",
          },
          { key: "status", label: "Status", color: "status" },
          {
            key: "completedAt",
            label: "Withdrawn Completed On",
            format: "dateTime",
          },
          { key: "amount", label: "Requested Amount", format: "currency" },
          { key: "bankName", label: "To Bank Account" },
          { key: "accountNumber", label: "Account Number", format: "mask" },
        ];
      case "In Progress":
        return [
          { key: "transactionId", label: "Transaction ID", format: "id" },
          {
            key: "initiatedAt",
            label: "Withdrawn Requested On",
            format: "dateTime",
          },
          { key: "status", label: "Status", color: "status" },
          {
            key: "completedAt",
            label: "Withdrawn Completed On",
            format: "dateTime",
          },
          { key: "amount", label: "Requested Amount", format: "currency" },
          { key: "bankName", label: "To Bank Account" },
          { key: "accountNumber", label: "Account Number", format: "mask" },
        ];
      case "Canceled":
        return [
          {
            key: "initiatedAt",
            label: "Withdrawn Requested On",
            format: "dateTime",
          },
          { key: "amount", label: "Requested Amount", format: "currency" },
          { key: "status", label: "Status", color: "status" },
          {
            key: "completedAt",
            label: "Withdrawn Cancelled On",
            format: "dateTime",
          },
          { key: "bankName", label: "To Bank Account" },
          { key: "accountNumber", label: "Account Number", format: "mask" },
        ];
      case "Rejected":
        return [
          {
            key: "initiatedAt",
            label: "Withdrawn Requested On",
            format: "dateTime",
          },
          { key: "amount", label: "Requested Amount", format: "currency" },
          { key: "status", label: "Status", color: "status" },
          {
            key: "completedAt",
            label: "Withdrawn Rejected On",
            format: "dateTime",
          },
          { key: "bankName", label: "To Bank Account" },
          { key: "accountNumber", label: "Account Number", format: "mask" },
          { key: "transactionDescription", label: "Rejected Reason" },
        ];
      default:
        return [];
    }
  },
  "Funds Unlocked": [
    { key: "auctionId", label: "Auction ID", format: "id" },
    { key: "auctionTime", label: "Auction Time", format: "zoneDateTime" },
    { key: "auctionAddress", label: "Property Address" },
    { key: "initiatedAt", label: "Unlocked Time", format: "dateTime" },
    { key: "status", label: "Status", color: "status" },
  ],
  "Funds Locked": [
    { key: "auctionId", label: "Auction ID", format: "id" },
    { key: "auctionTime", label: "Auction Time", format: "zoneDateTime" },
    { key: "auctionAddress", label: "Property Address" },
    { key: "initiatedAt", label: "Locked Time", format: "dateTime" },
    { key: "status", label: "Status", color: "status" },
  ],
  "Auction Settlement": [
    { key: "auctionId", label: "Auction ID", format: "id" },
    { key: "auctionTime", label: "Auction Time", format: "zoneDateTime" },
    { key: "auctionAddress", label: "Property Address" },
    { key: "amount", label: "Winning Bid Amount", format: "currency" },
    { key: "completedAt", label: "Funds Settled On", format: "dateTime" },
    { key: "status", label: "Status", color: "status" },
  ],
};

const DynamicDialog = ({
  open,
  onClose,
  payload,
}: {
  open: boolean;
  onClose: any;
  payload: any;
}) => {
  const formatValue = (value: any, format: any) => {
    if (!value) return "-";
    switch (format) {
      case "dateTime":
        return <DateFormatter date={value} />;
      case "zoneDateTime":
        return moment(value).format("MMM DD, YYYY hh:mm A");
      case "currency":
        return `$${new Intl.NumberFormat("en-US").format(value)}`;
      case "mask":
        return (
          <span className="big-asterisk">
            &#10034;&#10034;&#10034;&#10034;{value.slice(-4)}
          </span>
        );
      case "id":
        return `#${value}`;

      default:
        return value;
    }
  };

 const fields =
    typeof fieldMappings[payload?.description] === "function"
      ? fieldMappings[payload?.description](payload)
      : fieldMappings[payload?.description] || [];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      sx={{ borderRadius: "10px", zIndex: 999999999 }}
      fullWidth
    >
      <DialogTitle>
        {payload.description || "Details"}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <hr />
      <DialogContent sx={{ p: 2.5 }}>
        <Grid container rowGap={1} columnSpacing={2} alignItems={"baseline"}>
          {fields.map(({ key, label, format, color }) => (
            formatValue(payload[key], format) !== "-" && <React.Fragment key={key}>
              <Grid item xs={5} display={"flex"} columnGap={1}>
                <Typography fontSize={16} variant="body2" fontWeight="medium">
                  {label}
                </Typography>
                <Typography>:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={16}
                  variant="body2"
                  fontWeight="medium"
                  sx={{
                    color:
                      color === "status"
                        ? payload[key]?.toLowerCase() === "successful" ||
                          payload[key]?.toLowerCase() === "completed"
                          ? "green"
                          : payload[key]?.toLowerCase() === "cancelled" ||
                            payload[key]?.toLowerCase() === "canceled" ||
                            payload[key]?.toLowerCase() === "rejected" ||
                            payload[key]?.toLowerCase() === "failed"
                          ? "#EF233C"
                          : payload[key]?.toLowerCase() === "in progress"
                          ? "#ffdf00"
                          : "#3b3b3b"
                        : "inherit",
                  }}
                >
                  {formatValue(payload[key], format)}
                </Typography>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
        <Divider sx={{ marginTop: 1 }} />
      </DialogContent>
    </Dialog>
  );
};
export default DynamicDialog;
